import Api from '@/services/Api'

export default {
    getAllActivos(){
        return Api().get('activos/getAll')
    },
    getActivoById(id){
        return Api().get('activos/activoById/'+id)
    },
    getActivoByTipoActivo(tipoActivo){
        return Api().get('activos/activoByTipoActivo/'+tipoActivo)
    },
    createActivo(datos){
        return Api().post('activos/create',datos)
    },
    updateActivoById(datos){
        return Api().put('activos/update',datos)
    },
    inactivateActivo(id){
        return Api().put('activos/inactivate/'+id)
    },
    leaActivosColocar(identificacion,tipoActivo){
        return Api().get('activos/leaActivosColocar/'+tipoActivo+'/'+identificacion)
    },
    addNewActivoAlContrato(datos){
        return Api().post('activos/addActivoContrato',datos)
    },
    quitarActivoAlContrato(datos){
        return Api().post('activos/quitarActivoContrato',datos)
    },
    mejoraRetiro(datos){
        return Api().post('activos/mejoraRetiro',datos)
    },
}
